export default __webpack_public_path__ + "static/media/avatar_trex9.fb5a957b.mp3";